import { parsePhoneNumberFromString } from 'libphonenumber-js/max'

export const isPhoneValidWithCountryCode = (isoCode, phoneNumber) => {
  // lib will return undefined if no valid phone number can be parsed.
  const parsed = parsePhoneNumberFromString(phoneNumber, isoCode)
  if (!parsed) return false

  return parsed.isPossible()
}
